











































































































































































































































import axios from 'axios';
import { get } from 'lodash';
import EventBus from '@/eventBus';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoSelect from '@/components/Molecules/co-select/CoSelect.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoSwitch from '@/components/Atoms/co-switch/CoSwitch.vue';
import CoLabel from '@/components/Atoms/co-label/CoLabel.vue';
import CoTippy from '@/components/Atoms/co-tippy/CoTippy.vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import { CreateCustomFieldRequest, CustomField } from './models.ts';

export default {
    name: 'CustomFields',
    components: {
        CoTable,
        CoInput,
        CoButton,
        CoSelect,
        CoModal,
        CoFormGroup,
        CoConfirmation,
        CoDate,
        CoSwitch,
        CoIcon,
        CoLabel,
        CoTippy,
    },
    data() {
        return {
            fields: [],
            loading: false,
            searchInput: '',
            creating: false,
            updating: false,
            deleting: false,
            options_values: '', // comma-separated string for new field options
            newField: {
                identifier: 'cf_',
                label: '',
                data_type: 'text',
                options_values: [],
                visibility: 'admin',
                editability: 'admin',
                requested_on_sign_up: 'none',
                use_for_matching: false,
                sort_order: 1,
            } as CreateCustomFieldRequest,
            editfield: {} as CustomField,
            dataTypeOptions: [
                { Value: 'text', Name: this.$t('labels.cf.datatypetext') },
                { Value: 'number', Name: this.$t('labels.cf.datatypenumber') },
                { Value: 'date', Name: this.$t('labels.cf.datatypedate') },
                { Value: 'boolean', Name: this.$t('labels.cf.datatypeboolean') },
                { Value: 'select', Name: this.$t('labels.cf.datatypeselect') },
                { Value: 'multiselect', Name: this.$t('labels.cf.datatypemultiselect') },
                { Value: 'link', Name: this.$t('labels.cf.datatypelink') },
            ],
            visibilityOptions: [
                { Value: 'admin', Name: this.$t('labels.cf.visibilityadmin') },
                // { Value: 'moderator', Name: 'Moderator' },
                { Value: 'owner', Name: this.$t('labels.cf.visibilityowner') },
                { Value: 'community', Name: this.$t('labels.cf.visibilitycommunity') },
                // { Value: 'public', Name: this.$t('labels.cf.visibilitypublic') },
            ],
            editabilityOptions: [
                { Value: 'admin', Name: this.$t('labels.cf.editabilityadmin') },
                // { Value: 'moderator', label: 'Moderator' },
                { Value: 'owner', Name: this.$t('labels.cf.editabilityowner') },
            ],
            signUpOptions: [
                { Value: 'none', Name: this.$t('labels.cf.requestedonsignupnone') },
                { Value: 'optional', Name: this.$t('labels.cf.requestedonsignupoptional') },
                { Value: 'required', Name: this.$t('labels.cf.requestedonsignuprequired') },
            ],
        };
    },
    watch: {
        options_values(newVal) {
            if (this.editfield && this.editfield.id) {
                this.editfield.options_values = newVal.split(',').map((v) => v.trim());
            } else {
                this.newField.options_values = newVal.split(',').map((v) => v.trim());
            }
        },
        'newField.label': function (newVal) {
            if (newVal && !this.newField.identifierEdited) {
                this.newField.identifier = `cf_${newVal
                    .toLowerCase()
                    .replace(/\s+/g, '_')
                    .replace(/[^a-z0-9_]/g, '')}`;
            }
        },
    },
    computed: {
        planSlug() {
            return (
                (this.$store?.state?.space?.PlanSlug || this.$store?.state?.space_configuration_admin?.PlanSlug || '')
                    .toLowerCase()
                    .trim() || 'unknown'
            );
        },
        isLimitReached() {
            return this.fields.length >= (this.$store?.state?.limits?.Config?.max_custom_field || 100);
        },
        filteredFields() {
            if (!this.searchInput) return this.fields;
            return this.fields.filter(
                (f) =>
                    (f.label && f.label.toLowerCase().includes(this.searchInput.toLowerCase())) ||
                    (f.identifier && f.identifier.toLowerCase().includes(this.searchInput.toLowerCase()))
            );
        },
    },
    mounted() {
        this.listCustomFields();
    },
    methods: {
        emitCustomFieldsPaywall() {
            EventBus.$emit('PAYWALL', {
                feature: 'custom-fields',
                plan: this.planSlug || 'unknown',
            });
        },
        resetDataInNewCF() {
            this.newField = {
                identifier: 'cf_',
                label: '',
                data_type: 'text',
                options_values: [],
                visibility: 'admin',
                editability: 'admin',
                requested_on_sign_up: 'none',
                sort_order: 1,
            };
            this.options_values = '';
        },
        ensureIdentifierPrefix(input) {
            if (input === '') {
                this.newField.identifier = 'cf_';
            } else if (!input.startsWith('cf_')) {
                this.newField.identifier = `cf_${input.replace(/^cf_/, '')}`;
            } else {
                this.newField.identifier = input;
            }
        },
        showCreateModal() {
            if (this.isLimitReached) {
                this.emitCustomFieldsPaywall();
                return;
            }
            this.$refs.showCreateModal.show();
        },
        listCustomFields() {
            this.loading = true;

            axios
                .get('/admin/member/custom-fields?limit=100', { withCredentials: true })
                .then((response) => {
                    const objects = get(response, 'data.objects', []);
                    this.fields = objects.map((obj) => ({
                        ...obj.object,
                    }));
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        createCustomField() {
            if (this.isLimitReached) {
                this.emitCustomFieldsPaywall();
                return;
            }
            this.creating = true;
            axios
                .post('/admin/member/custom-fields', this.newField, { withCredentials: true })
                .then((response) => {
                    const createdField = get(response, 'data', null);
                    if (createdField) {
                        this.fields.unshift(createdField);
                    } else {
                        console.error('No field data returned from server.');
                        this.fields.unshift(this.newField as CustomField);
                    }
                    this.resetDataInNewCF();
                    this.$refs.showCreateModal.hide();

                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.cf.createdSuccessfully'),
                    });
                })
                .catch((error) => {
                    console.error('Error creating custom field:', error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.cf.creationFailed'),
                    });
                })
                .finally(() => {
                    this.creating = false;
                });
        },
        openEditModal(index, item) {
            this.editfield = { ...item };
            this.options_values = (item.options_values || []).join(',');

            this.$refs.editcfmodal.show();
        },
        resetEditCustomField() {
            this.options_values = '';
            this.editfield = {
                id: null,
                identifier: '',
                label: '',
                data_type: 'text',
                options_values: [],
                visibility: 'admin',
                editability: 'admin',
                requested_on_sign_up: 'none',
                sort_order: 0,
            };
        },
        editCustomField() {
            this.updating = true;

            axios
                .put('/admin/member/custom-fields', this.editfield, { withCredentials: true })
                .then((response) => {
                    this.listCustomFields();

                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.cf.updatedSuccessfully'),
                    });
                    this.$refs.editcfmodal.hide();
                })
                .catch((error) => {
                    console.error('Error updating custom field:', error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('messages.cf.updateFailed'),
                    });
                })
                .finally(() => {
                    this.updating = false;
                });
        },
        deletecf() {
            this.deleting = true;

            axios
                .delete(`/admin/member/custom-fields/${this.editfield.id}`, { withCredentials: true })
                .then(() => {
                    this.fields = this.fields.filter((field) => field.id !== this.editfield.id);
                    this.resetEditCustomField();
                    EventBus.$emit('INFO', {
                        Message: this.$t('messages.cf.deletedSuccessfully'),
                    });
                    this.$refs.editcfmodal.hide();
                })
                .catch((error) => {
                    console.error('Error deleting custom field:', error);
                    EventBus.$emit('ERROR', {
                        Message: this.$t('errors.failedGeneric'),
                    });
                })
                .finally(() => {
                    // add timeout
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.deleting = false;
                        }, 300);
                    });
                });
        },
    },
};
